import styled from 'styled-components';
import { devices, theme } from '@/styles/theme/index.jsx';

export const StyledBlogList = styled.div`

    position: relative;
	background: ${theme.colors.themeColor5};
	padding-top: 120px;
	padding-bottom: 80px;
	
	&.pdf{
        padding-top: 5%;
        padding-bottom: 5%;
        .pdf-viewer{
            pointer-events: auto !important;
			height: 80svh;
			position: relative;
			margin: 0 !important;
			width: 100vw !important;
            top: 45px;
        }
	}


    ${devices.lgMdMin} {
        .center-slider{
            .swiper-wrapper{
                justify-content: center;
                align-items: center;
            }
        }
	}
	
	
	.content-inner{
		margin-top: 40px;
		p{
            color: ${theme.colors.white};
            ${theme.mainFont}
		}
	}
	.info{

        p{
            color: ${theme.colors.white};
            &:first-child{
                margin-bottom: 8px;
                ${theme.mainTitle}
            }
            &:last-child{
                ${theme.backButtonList}
                margin: 0;
            }

        }
	}
    .image-wrapper{
        padding-top: ${theme.modalImageWrapper};
        position: relative;
        overflow: hidden;
        cursor: pointer;
		@media(max-width: 767px){
			margin-bottom: 40px;
		}
        &:after{
            content: '';
            ${theme.absoluteFill}
            ${theme.fullHeightWidth}
            background: ${theme.colors.modalImageWrapper};
        }

        .global-image{
            transition: ${theme.transition};
            transform: scale(1.01);
        }
    }
	
    .close-button-ygen {
        position: absolute;
        top: 30px;
        right: 30px;
        z-index: 999;
        ${devices.sm} {
			top: 15px;
			right: 15px;
		}
    }
    .navigation_item {
        display: flex;
		right: 0;
		gap: 15px;
		z-index: 9;
		justify-content: flex-end;
		margin-top: 30px;
		li{
			list-style: none;
		}
    }
	
	.col-md-12{
		position: relative;
	}

    .image-blog-wrapper {
        padding-top: ${theme.modalBlogWrapper} !important;
		position: relative;
        img {
            ${theme.absoluteFill}
            ${theme.fullHeightWidth}
			object-fit: cover;
        }
    }


    ${devices.sm} {
		padding-top: 80px;
	}

`;
